import { Injectable, Inject, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Storage } from "@ionic/storage-angular"; 

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  renderer: any;
  private _storage: Storage | null = null;

  constructor(@Inject(DOCUMENT) private document: Document, 
              rendererFactory: RendererFactory2, 
              private storage: Storage) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.initStorage();
  }

  // 🔥 Inicializa o Storage antes de ser usado
  private async initStorage() {
    this._storage = await this.storage.create();
  }

  addBodyClass(bodyClass) {
    this.renderer.addClass(this.document.body, bodyClass);
  }

  removeBodyClass(bodyClass) {
    this.renderer.removeClass(this.document.body, bodyClass);
  }

  async toggleDarkTheme(isDark = true, needUpdate = true) {
    if (!this._storage) {
      await this.initStorage(); // Garante que o Storage foi inicializado antes do uso
    }

    if (needUpdate) await this._storage.set('darkMode', isDark);
    return isDark ? this.addBodyClass('dark-mode') : this.removeBodyClass('dark-mode');
  }

  async getCurrentSetting() {
    if (!this._storage) {
      await this.initStorage();
    }
    return this._storage.get('darkMode');
  }

  async restore() {
    if (!this._storage) {
      await this.initStorage();
    }

    const val = await this._storage.get('darkMode');
    this.toggleDarkTheme(val, false);
  }
}
